import ReviewTransferRequestDealer from '@deere/cps-it.warranty-model-factory/lib/review-transfer-request';
import moment from 'moment';

export const buildReviewTransferAcceptRejectPayload = (dealerRecommendation, operation) => {

    let reviewTransferRequestList;

    reviewTransferRequestList = [];
    dealerRecommendation.forEach(x => {

        const reviewTransferRequestDealer = new ReviewTransferRequestDealer({
            id: x.id,
            pin: x.pin
        });

        reviewTransferRequestList = [...reviewTransferRequestList, reviewTransferRequestDealer];

    });

    const reviewTransferRequestPayload = {
        operation,
        recommendations: reviewTransferRequestList
    };

    return reviewTransferRequestPayload;

};

export const buildReviewPinTransferAORPayload = (dealerRecommendation, operation, commentsDealerRecommendation) => {

    const modifiedDealerRecommendation = dealerRecommendation.map(x => ({
        ...x,
        reasonForChange: commentsDealerRecommendation,
        recommendation: {
            ...x.recommendation,
            responsibleAccountComments: commentsDealerRecommendation
        },
        requestDate: moment.utc().startOf('day').valueOf(),
        status: operation}));

    return modifiedDealerRecommendation;

};

export const buildPinTransferAORPayload = (dealerRecommendation, commentsDealerRecommendation) => {

    const modifiedDealerRecommendation = dealerRecommendation.map(x => ({
        ...x,
        reasonForChange: commentsDealerRecommendation,
        recommendation: {
            ...x.recommendation,
            responsibleAccountComments: commentsDealerRecommendation
        },
        requestDate: moment.utc().startOf('day').valueOf()
    }));

    return modifiedDealerRecommendation;

};



// WEBPACK FOOTER //
// ./src/product/shared/services/build-review-transfer-accept-reject-payload.js